import { render, staticRenderFns } from "./catalog-link.vue?vue&type=template&id=6638f5e3"
import script from "./catalog-link.vue?vue&type=script&lang=js"
export * from "./catalog-link.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports